import { createContext } from 'react';

import { bestFitInitialState } from '../constants.js';
import { HiveTileBestFitProps } from '../types/rendering.js';

export const HiveTileBestFitContext =
  createContext<HiveTileBestFitProps>(bestFitInitialState);
